import React from 'react';
import { Button } from './ui/Button';
interface MidCTAProps {
  displayTotal: string;
  checkoutUrl: string;
  onBeforeCheckout?: () => boolean;
}
export function MidCTA({
  displayTotal,
  checkoutUrl,
  onBeforeCheckout
}: MidCTAProps) {
  return <section className="bg-navy py-16 px-6 text-center" data-id="element-371">
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-6" data-id="element-372">
        <p className="text-xl md:text-2xl text-white font-body leading-relaxed" data-id="element-373">
          They were overwhelmed. They used this kit. They got through it. You
          can too — tonight.
        </p>

        <Button href={checkoutUrl} trackEvent="InitiateCheckout" className="text-xl px-8 py-5 w-full md:w-auto" onBeforeNavigate={onBeforeCheckout} data-id="element-374">
          GET THE SURVIVAL KIT + ALL 4 BONUSES — {displayTotal}
        </Button>

        <p className="text-sm text-white font-body" data-id="element-375">
          Instant Download | 30-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}